import React, { PropsWithChildren, HTMLAttributes } from "react";
import Loader from "ui/Loader/Loader";
import { cn } from "helpers/style";
import styles from "./Button.module.scss";

export type Props = PropsWithChildren<
  HTMLAttributes<HTMLButtonElement> & {
    orange?: boolean;
    gray?: boolean;
    blue?: boolean;
    deepBlue?: boolean;
    white?: boolean;
    outlined?: boolean;
    disabled?: boolean;
    loading?: boolean;
    spinnerColor?: string;
    fluid?: boolean;
    small?: boolean;
    ariaLabel?: string;
    alt?: string | number;
    as?: React.ElementType;
    rel?: string;
    className?: string;
    type?: "submit" | "reset" | "button";
  }
>;

const Button = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      ariaLabel = "",
      spinnerColor = "black",
      loading,
      orange,
      gray,
      blue,
      deepBlue,
      white,
      outlined,
      fluid,
      small,
      className,
      type = "button",
      ...props
    },
    ref
  ) => {
    return (
      <button
        type={type}
        className={cn([
          styles.button,
          orange && styles.buttonOrange,
          orange && outlined && styles.buttonOrangeOutlined,
          gray && styles.buttonGray,
          blue && styles.buttonBlue,
          deepBlue && styles.buttonDeepBlue,
          blue && outlined && styles.buttonBlueOutlined,
          white && styles.buttonWhite,
          white && outlined && styles.buttonWhiteOutlined,
          fluid && styles.buttonFluid,
          small && styles.buttonSmall,
          loading && styles.buttonLoading,
          className && className,
        ])}
        ref={ref}
        aria-label={ariaLabel}
        {...props}
      >
        {children}
        {!!loading && <Loader small spinnerColor={spinnerColor} />}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
